import Layout from "../../components/Layout";
import { useUserState } from "../../context/UserContext";
import Permission from "../error/Permission";
import AdminHostel from "./admin/index";
import StudentHostel from "./student/index";

const Hostel = () => {
  const { userRole } = useUserState();

  return (
    <Layout children={
      <>
        {userRole?.role === "school_admin" ? (
          <AdminHostel />
        ) : userRole?.role_type === "employee" ? <AdminHostel /> : userRole?.role_type === "student" ? <StudentHostel /> : (<Permission />)}
      </>
    }
    />
  );
};

export default Hostel;
